import { useNavigate, useParams } from 'react-router-dom';
import { PageLoadingSpinner } from 'shared/components/LoadingSpinner/PageLoadingSpinner';
import { useJobOrderIdByPublicOfferIdQuery } from 'shared/hooks/api/jobOrderIdByPublicOfferId/jobOrderIdByPublicOfferId.generated';
import { useSitemap } from 'shared/hooks/useSitemap';

export const NavigateOfferToJobOrder = () => {
  const sitemap = useSitemap();
  const navigate = useNavigate();

  const { offerId } = useParams();

  useJobOrderIdByPublicOfferIdQuery({
    variables: {
      offerId: offerId!,
    },
    onCompleted: ({ publicOffer }) =>
      navigate(sitemap.jobOrder(publicOffer.jobOrder.jobOrderId, offerId), {
        replace: true,
      }),
    onError: () =>
      navigate(sitemap.jobOrder('404'), {
        replace: true,
      }),
  });

  return <PageLoadingSpinner />;
};
